import styles from "./styles.module.scss";
//assets
import { ArrowUpIcon } from "../../assets";

export default function IncreaseStatistic({ percent }: { percent: string }) {
  return (
    <div className={styles.statsBody}>
      <div className={styles.arrowBody}>
        <ArrowUpIcon width={"10px"} className={styles.arrowUp} />
      </div>
      <p className={styles.increaseInfo}>{percent}</p>
    </div>
  );
}
